//region block: pre-declaration
//endregion
function incrementAndFetch(_this__u8e3s4) {
  return _this__u8e3s4.addAndFetch_fpau44_k$(1);
}
//region block: exports
export {
  incrementAndFetch as incrementAndFetchzsy670lf6w2h,
};
//endregion

//# sourceMappingURL=Atomics.common.mjs.map
